import React from "react";

export const TeamIdea = () => {
  return (
    <section
      data-aos="zoom-in-down"
      className="ourTeamIdea"
    >
      <div className="Idea2" ></div>
      <div className="Idea1" ></div>
      <div className="Idea3" >
        <div className="Idea3-content">
          <div className="Idea4" alt="Idea1"></div>
          <p className="Idea3-text">
            No matter what, we're here to help keep you and your love ones healthy
          </p>
        </div>
      </div>
      <div className="Idea5" ></div>
    </section>
  );
};
